// This icon file is generated automatically.
var PCheckSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M5.77 9.28c.2.27.6.27.8 0l3.3-4.57c.06-.08 0-.2-.1-.2h-.74a.5.5 0 00-.4.21L6.17 8.13 5.06 6.59a.5.5 0 00-.4-.21h-.74c-.1 0-.16.11-.1.2l1.95 2.7z" } }, { "tag": "path", "attrs": { "d": "M12.75.75H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zm-.63 11.38H1.88V1.87h10.25v10.25z" } }] }] }, "name": "p-check-square", "theme": "outlined" };
export default PCheckSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCheckSquareOutlined.js
// module id = 3278
// module chunks = 0